import { Game } from "@/models/game"
import { EnergySource } from "@/models/energy-source"
import { NotificationItem } from "@/models/notification"
import { getRandomInt } from "../functions/get-random-int"
import { AIPlayer } from "@/models/ai-player"
import { Event } from "@/models/events"

const SPEEDS = [100, 50, 30, 20, 10, 5]

const dayInMillis = 1000 * 60 * 60 * 24

export default {
    setTutorialIndex({ commit }: { commit: any }, index: number) {
        commit("SET_TUTORIAL_INDEX", index)
    },
    overviewStart({ commit }: { commit: any }) {
        commit("OVERVIEW_START")
    },
    overviewOver({ commit }: { commit: any }) {
        commit("OVERVIEW_OVER")
    },
    beginTutorial({ commit }: { commit: any }) {
        commit("BEGIN_TUTORIAL")
    },
    endTutorial({ commit }: { commit: any }) {
        commit("END_TUTORIAL")
    },
    toggleBook({ commit }: { commit: any }) {
        commit("TOGGLE_BOOK")
    },
    instructionsOver({ commit }: { commit: any }) {
        commit("INSTRUCTIONS_OVER")
    },
    instructionsRedo({ commit }: { commit: any }) {
        commit("INSTRUCTIONS_REDO")
    },
    startGame({ commit }: { commit: any }) {
        commit("START_GAME")
    },
    dismissEvent({ commit, state }: { commit: any, state: Game }) {
        if (!state.muted) {
            new Howl({
                src: ["/audio/Click.mp3"]
            }).play()
        }
        commit("DISMISS_EVENT")
    },
    popup({ commit }: { commit: any }, bool: boolean) {
        commit("POPUP", bool)
    },
    selectElement({ commit }: { commit: any }, element: EnergySource) {
        commit("SELECT_ELEMENT", element)
    },
    beginRound({ commit, dispatch, state }: { commit: any, dispatch: any, state: Game }) {
        commit("SET_TIMER", 0)
        commit("SET_ROUND_ACTIVE")
        // dispatch("initializeComputerPlayers")
        dispatch("roundLoop")
    },
    toggleMute({ commit }: { commit: any }) {
        commit("TOGGLE_MUTE")
    },
    nullTimer({ commit }: { commit: any }) {
        commit("SET_TIMER", dayInMillis)
    },
    roundLoop({ commit, dispatch, state }: { commit: any, dispatch: any, state: Game }) {
        if (state.roundActive && !state.paused) {
            commit("CHANGE_TIMER", state.roundSpeed)
            dispatch("computerAction")
            if (state.timeVal < dayInMillis && state.roundActive) {
                setTimeout(() => dispatch("roundLoop"), SPEEDS[state.roundSpeed])
            } else {
                // calculate earnings here (this occurs even if round ends)
                dispatch("calculateEarnings")
                // if the current day in the round is equal to the max day
                if (state.rounds![state.activeRound - 1].day === state.daysPerRound) {
                    commit("SET_TIMER", null)
                    dispatch("nextRound")
                } else {
                    // otherwise
                    // reset timer
                    commit("SET_TIMER", 0)
                    // increment day
                    commit("NEXT_DAY")
                    // roundloop
                    dispatch("roundLoop")
                }
            }
        }
    },
    modGameSpeed({ commit }: { commit: any }, increasing: boolean) {
        commit("MOD_GAME_SPEED", { increasing, SPEEDS })
    },
    calculateEarnings({ commit }: { commit: any }) {
        commit("CALCULATE_EARNINGS")
    },
    executeEvent({ commit, dispatch, state }: { commit: any, dispatch: any, state: Game }, event: Event) {
        if (event.dispatches != null) {
            event.dispatches!.forEach((d) => dispatch(d.name, d.payload))
        }
    },
    nextRound({ commit, dispatch, state }: { commit: any, dispatch: any, state: Game }) {
        commit("SET_ROUND_INACTIVE")
        commit("END_ROUND")
        const stuff = state.history.history[state.activeRound - 1]
        let returnVal = ""
        if (stuff != null) {
            const elements: EnergySource[] = Array.from(stuff.keys())
            for (const element of elements) {
                const num = stuff.get(element)!
                returnVal += `<p>${element.name}: ${num} units, ${element.mwatts * num} MW</p>`
            }
        } else {
            returnVal = "No purchases made."
        }
        const playerHistory = returnVal
        // const playerHistory = state.history.getHistoryAsString(state.activeRound)
        const mwatts = state.playerEnergy
        let fines
        let fine = null
        if (mwatts >= state.minMwatts!) {
            // don't fine
            fines = false
        } else {
            // fine
            fines = true
            fine = (state.minMwatts! - mwatts)
            // fine = getMaxPrice(state.energySources) * (state.minMwatts! - mwatts);
        }
        const payload = {
            history: playerHistory,
            mwatts,
            minMwatts: state.minMwatts!,
            fines,
            fine
        }
        // commit("RESET_ENERGY")
        commit("PROCESS_FINES", payload)

    },
    setMinMwatts({ commit, }: { commit: any }, mwatts: number) {
        commit("SET_MIN_MWATTS", mwatts)
    },
    setPrice({ commit }: { commit: any }, payload: { id: number, price: number }) {
        commit("SET_PRICE", payload)
    },
    setAmount({ commit }: { commit: any }, payload: { id: number, amount: number }) {
        commit("SET_AMOUNT", payload)
    },
    userPurchase({ commit, dispatch, state }: { commit: any, dispatch: any, state: Game }, payload: { item: EnergySource, amount: number }) {
        // add to inventory & history w/ addItem method
        commit("USER_PURCHASE", payload)
        commit("EDIT_STOCK", payload)
        dispatch("pollute", payload)
    },
    pollute({ commit }: { commit: any }, payload: { item: EnergySource, amount: number }) {
        const amount = payload.item.pollutionFactor * payload.amount
        commit("POLLUTE", amount)
    },
    pause({ commit }: { commit: any }) {
        commit("PAUSE")
    },
    unpause({ commit, dispatch }: { commit: any, dispatch: any }) {
        commit("UNPAUSE")
        dispatch("roundLoop")
    },
    newNotification({ commit }: { commit: any }, notification: NotificationItem) {
        commit("NEW_NOTIFICATION", notification)
    },
    computerPurchase({ commit, state }: { commit: any, state: Game }, payload: { cpu: AIPlayer, element: EnergySource }) {
        if (payload.element.units > 0) {
            commit("CPU_ACTED", payload)
            commit("EDIT_STOCK", { item: payload.element, amount: 1 })
        }
    },
    editMoney({ commit }: { commit: any }, money: number) {
        commit("EDIT_MONEY", money)
    },
    async computerAction({ dispatch, state }: { dispatch: any, state: Game }) {
        for (const cpu of state.aiPlayers) {
            // let AI consider making purchase with randomness.
            if ((cpu.timeActed == null || Date.now() - cpu.timeActed > cpu.cooldown)) {
                const currentTime = state.minsSinceMidnight
                const minTimeVal = 0 - ((0 * cpu.speed) / 100)
                if (minTimeVal <= currentTime) {
                    let type
                    switch (cpu.buyingType.type) {
                        case "random": {
                            const types = state.energySources
                            type = types[getRandomInt(0, types.length - 1)]
                            break
                        } case "explicit": {
                            const types = cpu.buyingType.types
                            if (types != null) {
                                type = types[getRandomInt(0, types.length - 1)]
                            }
                            break
                        } case "largest_availability": {
                            let max = null
                            for (const source of state.energySources) {
                                if (max == null || source.units > max) {
                                    type = source
                                    max = source.units
                                }
                            }
                            break
                        } case "cheapest_availability": {
                            let min = null
                            for (const source of state.energySources) {
                                if (min == null || source.price < min) {
                                    type = source
                                    min = source.price
                                }
                            }
                            break
                        }
                    }
                    dispatch("computerPurchase", {
                        cpu,
                        element: type
                    })
                }
            }
        }
    }
}
